
import Vue from 'vue'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'

if (process.client) {
  const VueCryptojs = require('vue-cryptojs').default
  Vue.use(VueCryptojs)
}

// Declare globals for gtag
declare global {
  interface Window {
    gtag: any
  }
}
export default Vue.extend({
  name: 'Register',
  components: {
    VuePhoneNumberInput,
    Checkbox: () => import('primevue/checkbox'),
    InputText: () => import('primevue/inputtext'),
    Button: () => import('primevue/button'),
    OtpInput: () => import('~/components/OtpInput.vue')
  },
  layout: 'footer',
  data () {
    return {
      orp: false,
      picture: {
        critical: true,
        sources: [
          // { src: './assets/images/test/registration/platform-reg-mob.png', sizes: { sm: '100vw', md: '100vw', lg: '100vw', xl: '100vw', xxl: '100vw' }, media: { 'max-width': '688px' } },
          { src: './assets/images/test/registration/platform-reg-desk.png', sizes: { sm: '420px', md: '420px', lg: '420px', xl: '420px', xxl: '420px' } }
        ],
        title: 'Image Title',
        alt: 'Image Alt',
        class: 'decoration'
      },
      secret: 'CVing secret',
      step: 'form' as 'form' | 'otp' | 'success',
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      formattedNumber: '',
      phoneIsValid: false,
      error: '',
      emailError: '',
      firstNameError: '',
      lastNameError: '',
      submitTried: false,
      $gtm: null,
      terms1: false,
      terms2: false,
      suggestion: null,
      // OTP verification
      otp: '',
      otpError: '',
      otpLoading: false,
      otpRemainingTime: 0,
      otpTimerInterval: null as ReturnType<typeof setInterval> | null
    }
  },
  head: {
    title: 'Signup - CVing',
    meta: [
      { hid: 'robots', name: 'robots', content: 'noindex,follow' }
    ]
  },
  computed: {
    orpSuggestion() {
      if (process.client) {
        const pendingOrp = sessionStorage.getItem('pending_orp_suggestion')
        return pendingOrp ? JSON.parse(pendingOrp) : null
      }
      return null
    },
    formatOtpTime(): string {
      const minutes = Math.floor(this.otpRemainingTime / 60)
      const seconds = this.otpRemainingTime % 60
      return `${minutes}:${seconds.toString().padStart(2, '0')}`
    }
  },
  created () {
    // Only redirect if user is logged in AND we're on the initial form step
    // (not during phone-verify or success steps after registration)
    /*
    if (this.$auth.loggedIn && this.step === 'form') {
      this.$router.push(this.localePath('index'))
    }
    */
    if (this.orpSuggestion && this.orpSuggestion.cid) {
      this.track('signup', 'start', '')
    }
    // Pre-fill email from query parameter
    if (this.$route.query.email) {
      this.email = this.$route.query.email as string
    }
  },
  beforeDestroy() {
    this.clearOtpTimer()
  },
  methods: {
    clearOrpSuggestion() {
      if (process.client) {
        sessionStorage.removeItem('pending_orp_suggestion')
      }
    },

    track(stepName: string, stepStage: string, actionStep: string) {
      if (this.orpSuggestion && this.orpSuggestion.cid) {
        const ita = this.orpSuggestion?.company?.coid === 594
        let data: { [k: string]: any } = {}
        data = {
          company_name: this.orpSuggestion?.campaign?.company?.co_name,
          job_application_name: this.orpSuggestion?.campaign?.title,
          job_application_place: this.orpSuggestion?.campaign?.city,
          is_stage: this.orpSuggestion?.campaign?.contract_type === 8,
          verified: this.orpSuggestion?.campaign?.verified,
          orp: this.orpSuggestion?.campaign?.verified && !this.orpSuggestion?.campaign?.expired && !ita && this.orpSuggestion?.campaign?.p2p && this.$config.p2p,
          orp_value: Number(this.orpSuggestion?.campaign?.unlockamount),
          page_url: this.$router.currentRoute.fullPath,
          page_title: 'Signup',
          step_name: stepName,
          step_stage: stepStage,
          action_step: actionStep,
          logged: this.$auth?.loggedIn
        }
        this.$gtm.push({
          event: 'orp_program_v2',
          event_data: data
        })
      }
    },
    userLogin() {
      if (this.orpSuggestion && this.orpSuggestion.cid) {
        this.track('signup', 'end', 'login')
      }
      this.$router.push({ name: 'login' })
    },

    validateName(name) {
      // Reject URLs and HTML to prevent hyperlink/markup injection into
      // system-generated emails (e.g. "https://evil.com" in the Name field).
      return !/(:\/\/|www\.|[<>])/i.test(name)
    },
    validateEmail(email) {
      if (!email || typeof email !== 'string') {
        return false
      }
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    },
    updatePhoneNumber(data: any) {
      const newFormattedNumber = data.formattedNumber !== undefined
        ? data.formattedNumber
        : data.phoneNumber

      this.formattedNumber = newFormattedNumber
      this.phoneIsValid = data.isValid
    },
    async registerUser() {
      this.submitTried = true
      this.error = ''
      this.emailError = ''
      this.firstNameError = ''
      this.lastNameError = ''
      if (!this.validateEmail(this.email)) {
        this.emailError = this.$t('login.notValidEmail').toString()
      }
      if (this.firstName.trim() !== '' && !this.validateName(this.firstName)) {
        this.firstNameError = this.$t('signup.invalidName').toString()
      }
      if (this.lastName.trim() !== '' && !this.validateName(this.lastName)) {
        this.lastNameError = this.$t('signup.invalidName').toString()
      }
      if (!this.phoneIsValid) {
        return
      }
      if (!this.emailError && !this.firstNameError && !this.lastNameError && this.phoneIsValid) {
        this.submitTried = false
        try {
          this.$nuxt.$loading?.start()
          let params: any = {}
          params = {
            uid: 0,
            email: this.email.trim(),
            facebook_id: '',
            linkedin_id: '',
            user_name: this.email.trim(),
            first_name: this.firstName.trim(),
            last_name: this.lastName.trim(),
            account: 2,
            phone: this.formattedNumber,
            new_password: '',
            new_email: '',
            newsletter: this.terms2,
            terms: true,
            locale: this.$i18n.locale
          }
          if (this.orpSuggestion && this.orpSuggestion.cid) {
            let clientId = null
            let sessionId = null

            const getClientId = () => {
              return new Promise((resolve) => {
                window.gtag('get', 'G-QB45E7C0YX', 'client_id', (clientID) => {
                  resolve(clientID)
                })
              })
            }

            const getSessionId = () => {
              return new Promise((resolve) => {
                window.gtag('get', 'G-QB45E7C0YX', 'session_id', (sessionID) => {
                  resolve(Number(sessionID))
                })
              })
            }
            if (window?.gtag) {
              clientId = await getClientId()
              sessionId = await getSessionId()
            }
            const refferedDirectInviteData = {
              nameReferredCandidate: this.orpSuggestion.name,
              lastNameReferredCandidate: this.orpSuggestion.surname,
              mailReferredCandidate: this.orpSuggestion.email,
              messageCustom: this.orpSuggestion.message,
              phoneNumber: this.orpSuggestion.phone,
              Cid: Number(this.orpSuggestion.cid),
              analytics: {
                client_id: clientId,
                session_id: sessionId
              }
            }

            params.refferedDirectInviteData = refferedDirectInviteData
          }

          // Check for pending MBTI from sessionStorage
          if (process.client) {
            const pendingMbti = sessionStorage.getItem('pending_mbti')
            if (pendingMbti) {
              params.mbti = pendingMbti
            }
          }
          await this.$axios.post('/proxyapi/signup', params)

          // Clear pending MBTI after successful signup
          if (process.client) {
            sessionStorage.removeItem('pending_mbti')
          }

          const encryptedEmail = (this as any).$CryptoJS.AES.encrypt(this.email.trim(), this.secret).toString()
          this.$gtm.push({
            event: 'sign_up',
            event_data: {
              sign_up_platform: 'main_site',
              sign_up_method: 'otp - email',
              user_id: encryptedEmail,
              page_url: this.$router.currentRoute.fullPath,
              page_title: document ? document?.title : 'CVing'
            }
          })
          if (this.orpSuggestion && this.orpSuggestion.cid) {
            this.track('signup', 'end', 'registered')
          }
          // Move to OTP step and start timer
          this.step = 'otp'
          this.startOtpTimer(300) // 5 minutes
          this.$nextTick(() => {
            if (this.$refs.otpInput) {
              (this.$refs.otpInput as any).focus()
            }
          })
        } catch (error: any) {
          console.log('error', error)
          this.error = error?.response?.data?.error
          this.$nuxt.$loading?.finish()
        } finally {
          this.$nuxt.$loading?.finish()
        }
      }
    },

    // OTP Methods
    handleOtpInput() {
      this.otpError = ''
    },

    async verifyOtp() {
      if (this.otp.length !== 6) {
        return
      }

      this.otpLoading = true
      this.otpError = ''

      try {
        // Call login API directly to avoid automatic redirect from $auth.loginWith
        const response = await this.$axios.post('/proxyapi/login-passwordless', {
          email: this.email.trim(),
          otp: this.otp
        })

        // Manually set the token and fetch user data
        await this.$auth.setUserToken(response.data.token)
        await this.$auth.fetchUser()

        this.clearOtpTimer()
        // Go to success step
        this.step = 'success'
      } catch (error: any) {
        if (error.response?.status === 401) {
          this.otpError = this.$t('signup.invalidOtp').toString()
        } else {
          this.otpError = error.response?.data?.error || this.$t('signup.otpVerifyError').toString()
        }
      } finally {
        this.otpLoading = false
      }
    },

    async resendOtp() {
      this.otpLoading = true
      this.otpError = ''
      this.otp = ''

      try {
        await this.$axios.post('/proxyapi/request-otp', {
          email: this.email.trim(),
          method: 'email'
        })

        this.startOtpTimer(300) // 5 minutes
        this.$nextTick(() => {
          if (this.$refs.otpInput) {
            (this.$refs.otpInput as any).focus()
          }
        })
      } catch (error: any) {
        this.otpError = error.response?.data?.error || this.$t('signup.otpResendError').toString()
      } finally {
        this.otpLoading = false
      }
    },

    startOtpTimer(seconds: number) {
      this.otpRemainingTime = seconds
      this.clearOtpTimer()
      this.otpTimerInterval = setInterval(() => {
        this.otpRemainingTime--
        if (this.otpRemainingTime <= 0) {
          this.clearOtpTimer()
        }
      }, 1000)
    },

    clearOtpTimer() {
      if (this.otpTimerInterval) {
        clearInterval(this.otpTimerInterval)
        this.otpTimerInterval = null
      }
    },

    goBackToForm() {
      this.step = 'form'
      this.otp = ''
      this.otpError = ''
      this.clearOtpTimer()
      this.error = ''
    }
  }
})
